import { v4 as uuidv4 }         from 'uuid';
import { fabric }               from 'fabric';

const labelVisibility = { 
    mt: false, mb: false, ml: false, mr: false,
    bl: true, br: true, tl: true, tr: true, mtr: false
};

const defaultLabelOpt = {
    cornerSize:         8,
    cornerColor:        '#1e4591',
    cornerStyle:        'circle',
    borderColor:        '#1e4591',
    strokeWidth:        2,
    centeredScaling:    false,
    strokeUniform:      true,
    selectable:         false,
    scalable:           true,
    evented:            false,
    hasControls:        false,
    lockRotation:       true,
    lockScalingFlip:    true,
    lockScalingX:       false,
    lockScalingY:       false,
    flipX:              false,
    flipY:              false,
    perPixelTargetFind: true,
    originX:            'left',
    originY:            'top',
    elementType:        'bbRect',
    noScaleCache:       false,
    transparentCorners: false,
    isTemporary:        true
};

const defaultPathOpt = {
    fill: 			    null,
    shadow: 		    null,
    erasable: 		    true,
    strokeUniform:      true,
    evented: 		    true,
    selectable: 	    false,
    centeredScaling:    false,
    paintFirst: 	    'fill',
    strokeLineCap:	    'round',
    strokeLineJoin:	    'round',
    elementType:        'mask',
    isTemporary:        true
};

export function createLabel (opt = {}, samOpt = false) {
    const fabricLabel = new fabric.Rect({
        ...defaultLabelOpt,
        uuid:               uuidv4(),
        id:                 opt.id      || null,
        name:               opt.name    || null,
        color:              opt.color,
        stroke:             opt.color,
        fill:               opt.fill,
        height:             opt.height,
        width:              opt.width,
        top:                opt.top,
        left:               opt.left,
        strokeDashArray:    opt.strokeDashArray || null,
    });

    if (samOpt) {
        fabricLabel.set({
            samDetection:       true,
            previousPoints:     opt.previousPoints,
            previousBB:         opt.previousBB
        })
    }

    fabricLabel.setCoords();
    fabricLabel.setControlsVisibility(labelVisibility);

    return fabricLabel;
}

export function createPath (data, opt = {}, samOpt = false) {
    const fabricPath = new fabric.Path(data, {
        ...defaultPathOpt,
        uuid:           uuidv4(),
        id:             opt.id      || null,
        name:           opt.name    || null,
        color:          opt.color,
        stroke:         opt.color,
        opacity:        opt.opacity,
        strokeWidth:    opt.strokeWidth || 2,
    });

    if (samOpt) {
        fabricPath.set({
            samDetection:       true,
            fill:               opt.color,
            previousPoints:     opt.previousPoints,
            previousBB:         opt.previousBB
        })
    }

    return fabricPath;
}